import Api from './Api';
import Csrf from "./Csrf";

export default {
    async getCurrentPortalSubscriptionFees(session_id) {
        await Csrf.getCookie();
        return Api.get('/subscription-fees/'+session_id+'/current-fee');
    },
};